module.exports = __webpack_public_path__ + "static/media/client project.faee9d26.svg";